import { motion } from 'framer-motion';
import { Shield, Users, Building2, Activity } from 'lucide-react';

export default function Superadmin() {
  const stats = [
    { label: 'Total Users', value: '5,678', icon: Users, color: 'bg-medical-500' },
    { label: 'Hospitals', value: '28', icon: Building2, color: 'bg-medical-600' },
    { label: 'System Health', value: '98%', icon: Activity, color: 'bg-medical-400' },
    { label: 'Admin Access', value: 'Full', icon: Shield, color: 'bg-medical-700' },
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-white rounded-xl shadow-sm p-6"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-slate-500 mb-1">{stat.label}</p>
                <p className="text-2xl font-bold text-slate-800">{stat.value}</p>
              </div>
              <div className={`${stat.color} p-3 rounded-lg`}>
                <stat.icon className="w-6 h-6 text-slate-900" />
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="bg-white rounded-xl shadow-sm p-6"
      >
        <h3 className="text-lg font-semibold text-slate-800 mb-4">Super Admin Dashboard</h3>
        <p className="text-slate-600">Complete system overview and management controls.</p>
      </motion.div>
    </div>
  );
}
